<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/weier/sample/information/page" ref="yt" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinbianma/mingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yangbenleixing')">
            <yi_dictionary_select :max="1" :type="'QUALITY_SAMPLE_INFO_TYPE'" :ids.sync="yt.conditions.sampleType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifoushengxiao')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-button @click="yt.get(1)" type="primary" plain size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="yt.clear()" size="mini">{{ $t('chongzhi') }}</el-button>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1')">
          {{ $t('xinzeng') }}
        </el-button>

        <el-button size="mini" type="primary" @click="yt.showEditDialog('daoru', null, 'w2')">
          {{ $t('daoru') }}
        </el-button>

        <el-button size="mini" type="primary" @click="yt.showEditDialog('xiugaijilu', null, '1300px')">
          {{ $t('xiugaijilu') }}
        </el-button>
      </template>

      <template #buttonsR>
        <el-button :loading="weight_info_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-button size="mini" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">
            {{ $t('bianji') }}
          </el-button>
          <el-button size="mini" type="text" @click="yt.remove(scope.row, '/custom/weier/sample/information/delete')">
            {{ $t('shanchu') }}
          </el-button>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required="required">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yangbenleixing')" required="required">
            <yi_dictionary_select :max="1" :type="'QUALITY_SAMPLE_INFO_TYPE'" :ids.sync="yt.editObj.sampleType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('kaishishengxiaoshijian')" required="required">
            <el-date-picker v-model="yt.editObj.startDate" type="date" placeholder="选择日期" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('jieshushengxiaoshijian')" required>
            <el-date-picker v-model="yt.editObj.endDate" type="date" placeholder="选择日期" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="2" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/custom/weier/sample/information/create')" :loading="yt.editObj.loading" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '样品信息-新增样品信息' } }">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required="required">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId" disabled></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yangbenleixing')" required="required">
            <yi_dictionary_select :max="1" :type="'QUALITY_SAMPLE_INFO_TYPE'" :ids.sync="yt.editObj.sampleType" disabled> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('kaishishengxiaoshijian')" required="required">
            <el-date-picker v-model="yt.editObj.startDate" type="date" placeholder="选择日期" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('jieshushengxiaoshijian')" required>
            <el-date-picker v-model="yt.editObj.endDate" type="date" placeholder="选择日期" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="2" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/custom/weier/sample/information/update')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'xiugaijilu'">
        <div class="dialog-scroller">
          <updateLog></updateLog>
        </div>
      </template>

      <template v-if="yt.editObj.action === 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import @loading-start="startLoading" @loading-stop="stopLoading" ref="weierSampleImportTemplate" :templatekey="'weier_sample_import_template'" :uploadApi="'/custom/weier/sample/information/batchImportValidate'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :disabled="importLoading" @click="mainSubImportData" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '样品信息-导入' } }">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import updateLog from './update_log';
export default {
  name: 'web_customize_weier_sample_info_list',
  components: {
    updateLog
  },
  data() {
    return {
      importLoading: false,
      saveData: {},
      columns: [
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'yangbenleixing',
          type: 'dictionary',
          key: 'QUALITY_SAMPLE_INFO_TYPE',
          prop: 'sampleType'
        },
        {
          label: 'kaishishengxiaoshijian',
          type: 'time',
          prop: 'startDate'
        },
        {
          label: 'jieshushengxiaoshijian',
          prop: 'endDate',
          type: 'time'
        },

        {
          label: 'shifoushengxiao',
          prop: 'status',
          type: 'tag',
          tags: {
            0: {
              color: '#419FFF',
              text: this.$t('fou')
            },
            1: {
              color: '#419FFF',
              text: this.$t('shi')
            }
          }
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    startLoading() {
      this.importLoading = true;
    },
    stopLoading() {
      this.importLoading = false;
    },
    mainSubImportData() {
      let data = [...this.$refs.weierSampleImportTemplate.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.weierSampleImportTemplate.listLength == null || this.$refs.weierSampleImportTemplate.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/custom/weier/sample/information/batchImportValidate?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    exportExcel() {
      this.weight_info_export_loading = true;
      //查询表格
      this.http
        .get('/custom/weier/sample/information/page?page=1&limit=10000', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => {
            if (i.label != 'caozuo') {
              return this.$t(i.label);
            }
          });
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i],tableFirst);
            tableData.push(dataArr);
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `样品信息-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.weight_info_export_loading = false;
        });
    },
    getTableDataArr(row,tableFirst) {
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('chanpinbianma'))] = row.material.code;
      dataArr[tableFirst.indexOf(this.$t('chanpinmingcheng'))] = row.material.name;
      dataArr[tableFirst.indexOf(this.$t('yangbenleixing'))] = row.sampleType && row.sampleType === '1' ? '正式' : '临时';
      dataArr[tableFirst.indexOf(this.$t('kaishishengxiaoshijian'))] = row.startDate && this.dayjs(row.startDate).format('YYYY-MM-DD');
      dataArr[tableFirst.indexOf(this.$t('jieshushengxiaoshijian'))] = row.endDate && this.dayjs(row.endDate).format('YYYY-MM-DD');
      dataArr[tableFirst.indexOf(this.$t('shifoushengxiao'))] = row.status && row.status === 1 ? '是' : '否';
      dataArr[tableFirst.indexOf(this.$t('beizhu'))] = row.remark;
      dataArr[tableFirst.indexOf(this.$t('chuangjianren'))] = row.createByObject && row.createByObject.nickname;
      dataArr[tableFirst.indexOf(this.$t('chuangjianshijian'))] = row.createTime && this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss');
      return dataArr;
    }
  }
};
</script>
